import { Popup } from 'devextreme-react';
import { useCallback, useEffect, useRef, useState } from 'react';
import { DxReportViewer } from 'devexpress-reporting/dx-webdocumentviewer';
import * as ko from 'knockout';
import { ReportStruct, ReportType } from '../../../types/types.reports';
import deCore from '../../../localization/dx-analytics-core.es.json';
import deRep from '../../../localization/dx-reporting.es.json';

export const ModalReportConsentInform = ({ idOrden, IdCst, visible, setVisible, reportName }: { idOrden: number; IdCst: number; visible: boolean; setVisible: ({ visible }) => void; reportName: string }) => {
  const viewerRef = useRef<HTMLDivElement>(null);
  const viewerInstanceRef = useRef<any>(null);
  const [requestOptions, setRequestOptions] = useState({
    host: '',
    invokeAction: '',
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('/config.json');
        const data = await response.json();
        setRequestOptions({ host: `${data.apiUrl}/`, invokeAction: 'DXXRDV' });
      } catch (error) {
        console.error('Error fetching config data:', error);
      }
    };
    if (visible) {
      fetchData();
    }
  }, [visible]);

  useEffect(() => {
    if (!viewerRef.current || idOrden === -1 || !requestOptions.host || !visible || IdCst === -1) {
      return;
    }

    const myReport: ReportStruct = { Name: reportName, Type: ReportType.Consentimiento, Data: [idOrden], IdCst: IdCst };
    const reportUrl = ko.observable(JSON.stringify(myReport));
    const viewer = new DxReportViewer(viewerRef.current, {
      reportUrl,
      requestOptions,
      callbacks: {
        CustomizeMenuActions: (s, e) => {
          var search = e.Actions.find((x) => x.id === 'dxxrp-search');
          if (search) {
            search.visible = false;
          }
          var editingFields = e.Actions.find((x) => x.id === 'dxxrp-highlight-editing-fields');
          if (editingFields) {
            editingFields.visible = false;
          }

          var exportMenu = e.Actions.find((x) => x.id === 'dxxrp-export-menu');
          if (exportMenu) {
            exportMenu.visible = false;
          }

          var printPage = e.Actions.find((x) => x.id === 'dxxrp-print-page');
          if (printPage) {
            printPage.visible = false;
          }
        },
        CustomizeExportOptions: (s, e) => {
          e.HideExportOptionsPanel();
        },

        CustomizeLocalization: (s, e) => {
          e.LoadMessages(deCore);
          e.LoadMessages(deRep);
          s.UpdateLocalization({
            'Preview Parameters': 'Parámetros',
            Reset: 'Limpiar',
          });
        },
      },
    });
    viewerInstanceRef.current = viewer;
    try {
      viewer.render();
    } catch (err) {
      console.error('Error rendering report viewer', err);
    }

    return () => {
      try {
        if (viewerInstanceRef.current) {
          viewerInstanceRef.current.dispose();
          viewerInstanceRef.current = null;
        }
      } catch (err) {
        console.warn('Error disposing report viewer', err);
      }
      // clear DOM node to avoid leftover KO bindings on removed nodes
      try {
        if (viewerRef.current) viewerRef.current.innerHTML = '';
      } catch (err) {
        /* ignore */
      }
    };
  }, [idOrden, IdCst, requestOptions, visible, reportName]);

  const handleVisible = useCallback(() => {
    // dispose viewer immediately to avoid KO updates after DOM removal
    try {
      if (viewerInstanceRef.current) {
        try {
          viewerInstanceRef.current.dispose();
        } catch (err) {
          console.warn('Error disposing viewer on hide', err);
        }
        viewerInstanceRef.current = null;
      }
    } catch (err) {
      /* ignore */
    }
    try {
      if (viewerRef.current) viewerRef.current.innerHTML = '';
    } catch (err) {
      /* ignore */
    }

    // prefer calling the setter in the same shape used by parents
    try {
      setVisible({ visible: false });
    } catch (err) {
      // fallback: if parent expects a simple boolean
      try {
        // @ts-ignore
        setVisible(false);
      } catch (e) {
        // ignore
      }
    }
  }, [setVisible]);

  return (
    <Popup visible={visible} fullScreen={true} onHiding={handleVisible} title='Consentimiento informado' showCloseButton={true}>
      <div style={{ width: '100%', height: '100%' }}>
        <div ref={viewerRef}></div>
      </div>
    </Popup>
  );
};
